module.exports = __webpack_public_path__ + "media/pic1.456d44c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/insta/assets/pic1.jpg
// module id = ./src/templates/insta/assets/pic1.jpg
// module chunks = 0